import { Button, Divider, Space, Table, Typography } from "antd";
import { forwardRef, useEffect, useState } from "react";
import EUtils from "../../../utils/EUtils";
import Server from "../../../server/Server";
import URL from "../../../server/URL";
import EData from "../../../utils/EData";

const YearOrderCompanyReport = forwardRef((props: any, ref: any) => {
    const [days, setDays] = useState<number>(1)
    const [dataSource, setDataSource] = useState<any[]>([]);

    const columns: any[] = [
        { key: 'seqNO', title: '序号', dataIndex: 'seqNO', fixed: 'left', width: 30, align: 'right' },
        { key: 'name', title: '名称', dataIndex: 'name', fixed: 'left', width: 120, ellipsis: true },
        { key: 'count', title: '出单', dataIndex: 'count', width: 120, ellipsis: true, align: 'right' },
        { key: 'amount', title: '保费(元)', dataIndex: 'amount', width: 120, ellipsis: true, align: 'right' }
    ]


    const [scrollY, setScrollY] = useState("");

    const resize = () => setScrollY(EUtils.getTableScroll(35, ''));
    //页面加载完成后才能获取到对应的元素及其位置
    useEffect(() => {
        resize();
    }, [dataSource])

    useEffect(() => {
        onLoad();
    }, [days])

    const onLoad = () => {
        var request = {
            days: days ?? 1,
        };
        Server.Post(URL.YearOrder.GetYearOrderCompanyReport, request, false).then((response: any) => {
            if (response.isSuccess) {
                setDataSource(EData.AddDataSeqNO(response.data));
            }
        })
    }

    return <>
        <div style={{
            backgroundColor: '#fafafa', borderBottom: '1px solid #e7e7eb'
            , position: 'fixed', top: 0, zIndex: '999', width: '100%', height: '35px'
        }}>
            <span style={{ lineHeight: '32px', fontWeight: 'bold', margin: '5px' }}>
                年单分类汇总（保险公司）
            </span>
            <Space size={1} style={{ float: 'right', margin: '2px', lineHeight: '32px' }} split={<Divider type='vertical' />}>
                <Button type={days != 1 ? "link" : "text"} size={'small'} onClick={() => { setDays(1); }}>本周</Button>
                <Button type={days != 2 ? "link" : "text"} size={'small'} onClick={() => { setDays(2); }}>本月</Button>
            </Space>
        </div>
        <div style={{ marginTop: '35px' }}>
            <Table size="small" bordered
                scroll={dataSource?.length > 0 ? { x: 'max-content', y: scrollY } : { x: 'max-content' }}
                columns={columns} dataSource={dataSource} pagination={false}
                summary={(pageData) => {
                    var totalCount = 0;
                    var totalAmount = 0;
                    pageData.forEach(item => {
                        totalCount += item.count;
                        totalAmount += item.amount;
                    })
                    return <Table.Summary fixed>
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={1} >
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} colSpan={1} align={'left'}>
                                <Typography.Text>合计:{dataSource?.length}</Typography.Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={1} align={'right'}>
                                <Typography.Text>{totalCount}</Typography.Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={3} colSpan={1} align={'right'}>
                                <Typography.Text>{totalAmount}</Typography.Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={4} colSpan={2} >
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    </Table.Summary>
                }} />
        </div>
    </>
})
export default YearOrderCompanyReport;